export class Config {
    public static get ApiBaseUrl(): string {
        return (
            import.meta.env.VITE_API_BASE_URL || 
            'https://qa-api-gateway.tbcsandbox.com'
        );
    }

    public static get BaseUrl(): string {
        return import.meta.env.VITE_BASE_URL || 'BASE_URL';
    }

    public static get Environment(): string {
        return import.meta.env.VITE_ENVIRONMENT || 'local';
    }

    public static get FullStoryOrganizationId(): string {
        return import.meta.env.VITE_FULL_STORY_ORGANIZATION_ID || 'invalid';
    }

    public static get TimeZone(): string {
        return import.meta.env.VITE_TIMEZONE || 'America/Chicago';
    }

    public static get LaunchDarklyKey(): string {
        return (
            import.meta.env.VITE_LAUNCH_DARKLY_KEY ||
            '67cf3bde73e8a109891fcdb3'
        );
    }
    public static get FailedLoginAttemptsWarningThreshold(): number {
        return Number(
            import.meta.env.VITE_FAILED_LOGIN_ATTEMPTS_COUNT_WARNING || 1
        );
    }
    public static get FailedLoginAttemptsErrorThreshold(): number {
        return Number(
            import.meta.env.VITE_FAILED_LOGIN_ATTEMPTS_COUNT_ERROR || 1
        );
    }
}